
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"m0 0h24v24h-24z"}})]),_c('g',{attrs:{"clip-path":"url(#a)","clip-rule":"evenodd","fill":"#4a3428","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"m10.7967 7.13367c-1.07935 0-1.95433.83903-1.95433 1.87404v2.14179h-2.43099c-.57491 0-1.05589.4185-1.11152.9672l-.96666 9.5343c-.12763 1.2588.90409 2.349 2.22304 2.349h10.71226c1.319 0 2.3507-1.0902 2.223-2.349l-.9666-9.5343c-.0556-.5487-.5366-.9672-1.1115-.9672h-2.4288v-2.14179c0-1.03501-.875-1.87404-1.9544-1.87404zm2.5127 4.01583v-2.14179c0-.14786-.125-.26772-.2792-.26772h-2.2335c-.1542 0-.2792.11986-.2792.26772v2.14179zm-7.30892 10.657.89841-8.8612c.01091-.1076.10155-.1895.20975-.1895h9.60746c.1082 0 .1988.0819.2098.1895l.8984 8.8612c.0319.3147-.2261.5872-.5558.5872h-10.71226c-.32974 0-.58767-.2725-.55576-.5872z"}}),_c('path',{attrs:{"d":"m2.83613 4.34808c.3326-.32604.86653-.32073 1.19258.01187l2.21381 2.25833c.32604.3326.32073.86653-.01187 1.19258-.3326.32604-.86653.32072-1.19257-.01187l-2.21382-2.25834c-.32604-.33259-.32073-.86653.01187-1.19257z"}}),_c('path',{attrs:{"d":"m11.9117.281691c.4657-.000116.8434.377356.8435.843109l.0008 3.16244c.0001.46575-.3774.84341-.8431.84353-.4658.00011-.8434-.37736-.8435-.84311l-.0008-3.16244c-.0001-.465753.3773-.843414.8431-.843529z"}}),_c('path',{attrs:{"d":"m18.3005 7.53421c-.2794-.37261-.2039-.9012.1687-1.18065l2.53-1.89747c.3726-.27945.9012-.20393 1.1806.16867.2795.3726.2039.90119-.1687 1.18064l-2.5299 1.89747c-.3726.27945-.9012.20394-1.1807-.16866z"}})])])
          )
        }
      }
    